export default "__VITE_ASSET__BrPBg25H__"